export default __webpack_public_path__ + "static/media/automation.4d8342f8.png";